import { useState } from "react";
import { Calendar, Clock, MapPin } from "lucide-react";

const TAG_COLORS = {
    "Open House": "bg-orange",
    Workshop: "bg-forest",
    Gathering: "bg-brick",
    "Skill Swap": "bg-mustard !text-ink",
};

const PinnedCard = ({ event, rotate = "-1.5deg", onSelect }) => {
    const [imgFailed, setImgFailed] = useState(false);
    return (
        <article
            data-testid={`event-card-${event.id}`}
            onClick={onSelect ? () => onSelect(event) : undefined}
            onKeyDown={onSelect ? (e) => (e.key === "Enter" || e.key === " ") && onSelect(event) : undefined}
            tabIndex={onSelect ? 0 : undefined}
            role={onSelect ? "button" : undefined}
            className={`relative border-2 border-ink bg-paper p-6 pt-8 hard-shadow transition-transform duration-200 hover:-translate-y-1 ${onSelect ? "cursor-pointer" : ""}`}
            style={{ transform: `rotate(${rotate})` }}
        >
            <span className="tape-strip" aria-hidden="true" />
            {event.image && !imgFailed ? (
                <div data-testid={`event-card-thumb-${event.id}`} className="float-right mb-2 ml-3 rotate-3 border-2 border-ink bg-cream p-1 hard-shadow">
                    <img
                        src={event.image}
                        alt={`${event.title} flyer`}
                        loading="lazy"
                        referrerPolicy="no-referrer"
                        onError={() => setImgFailed(true)}
                        className="h-16 w-16 border border-ink bg-paper object-cover sm:h-20 sm:w-20"
                    />
                </div>
            ) : null}
            {event.tag ? (
                <span className={`inline-block border-2 border-ink px-2 py-0.5 font-display text-xs tracking-[0.15em] text-cream ${TAG_COLORS[event.tag] || "bg-forest"}`}>
                    {event.tag}
                </span>
            ) : null}
            <h3 className="mt-3 font-display text-2xl sm:text-3xl leading-tight tracking-wide text-ink">{event.title}</h3>
            <ul className="mt-3 space-y-1 text-sm font-semibold text-ink/80">
                <li className="flex items-center gap-2">
                    <Calendar className="h-4 w-4 text-orange" /> {event.date}
                </li>
                {event.time ? (
                    <li className="flex items-center gap-2">
                        <Clock className="h-4 w-4 text-orange" /> {event.time}
                    </li>
                ) : null}
                {event.location ? (
                    <li className="flex items-center gap-2">
                        <MapPin className="h-4 w-4 text-orange" /> {event.location}
                    </li>
                ) : null}
            </ul>
            {event.description ? <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-ink/75">{event.description}</p> : null}
            {onSelect ? (
                <p className="mt-4 inline-block border-2 border-ink bg-orange px-4 py-1.5 font-display text-sm tracking-[0.12em] text-cream hard-shadow transition-transform duration-200 hover:-translate-y-0.5 hover:-rotate-1">
                    Details →
                </p>
            ) : null}
        </article>
    );
};

export default PinnedCard;
